import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "getHeaderTitle", "actionMetadata"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import CreateSalesforceTaskActionDetail from 'automation-ui-action-features/actions/create-salesforce-task/CreateSalesforceTaskActionDetail';
import CreateSalesforceTaskActionMetadata from 'automation-ui-action-features/actions/create-salesforce-task/CreateSalesforceTaskActionMetadata';
import { jsx as _jsx } from "react/jsx-runtime";
class CreateSalesforceTaskActionCard extends Component {
  render() {
    const _this$props = this.props,
      {
        actionId,
        getHeaderTitle,
        actionMetadata
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
      headerTitle: getHeaderTitle({
        actionId
      }),
      content: /*#__PURE__*/_jsx(CreateSalesforceTaskActionDetail, {
        actionMetadata: actionMetadata
      })
    }));
  }
}
CreateSalesforceTaskActionCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(CreateSalesforceTaskActionMetadata).isRequired,
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default CreateSalesforceTaskActionCard;